import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { getHostBySlug } from '@/mocks/hostProfile';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import HostCoverHeader from './components/HostCoverHeader';
import HostProgramsSection from './components/HostProgramsSection';
import HostFeedSection from './components/HostFeedSection';
import HostVideosSection from './components/HostVideosSection';
import HostEventsSection from './components/HostEventsSection';
import HostStatsSection from './components/HostStatsSection';
import HostTopFansSection from './components/HostTopFansSection';
import HostBadgesSection from './components/HostBadgesSection';

export default function HostPage() {
  const { slug } = useParams<{ slug: string }>();
  const profile = slug ? getHostBySlug(slug) : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!profile) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center px-4">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-foreground-100 flex items-center justify-center">
              <i className="ri-user-search-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="text-2xl font-bold text-foreground-950 mb-2">Locutor no encontrado</h1>
            <p className="text-foreground-500 mb-6">El perfil que buscas no esta disponible en este momento.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl transition-all cursor-pointer text-sm"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      {/* Cover + Profile Header */}
      <HostCoverHeader profile={profile} />

      {/* Main content */}
      <main className="flex-1 max-w-5xl mx-auto px-4 md:px-6 py-6 md:py-8 w-full">
        <div className="space-y-6">
          {/* Programas */}
          <HostProgramsSection profile={profile} />

          {/* Publicaciones */}
          <HostFeedSection profile={profile} />

          {/* Videos */}
          <HostVideosSection profile={profile} />

          {/* Eventos */}
          <HostEventsSection profile={profile} />

          {/* Estadísticas públicas */}
          <HostStatsSection profile={profile} />

          {/* Top seguidores */}
          <HostTopFansSection profile={profile} />

          {/* Insignias */}
          <HostBadgesSection profile={profile} />
        </div>
      </main>

      <Footer />

      {/* Spacer for global player */}
      <div className="h-14 md:h-16"></div>
    </div>
  );
}